export default "__VITE_ASSET__NOhbKFdm__"